export const clientVersion = '2026-11-03';
